import React from 'react';
import './LegalPage.css';

const Cookies = () => (
    <div className="legal-page">
        <h1>Política de Cookies de Navi</h1>
        <p><strong>Fecha de última actualización:</strong> 06/06/2025</p>
        <p><strong>Dominio web:</strong> <a href="https://navitechlabs.com">https://navitechlabs.com</a></p>

        <h2>1. ¿Qué son las cookies?</h2>
        <p>Las cookies son pequeños archivos de texto que se almacenan en tu navegador cuando visitas sitios web. Su función es recopilar información sobre tu navegación y mejorar tu experiencia de usuario, recordar tus preferencias o analizar el uso de la web.</p>

        <h2>2. Tipos de cookies utilizadas en este sitio</h2>
        <table>
            <thead>
            <tr>
                <th>Tipo</th>
                <th>Finalidad</th>
                <th>Duración</th>
                <th>Titular</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Técnicas o necesarias</td>
                <td>Permiten la navegación y uso de las funciones básicas del sitio web.</td>
                <td>Sesión o persistentes</td>
                <td>Propias</td>
            </tr>
            <tr>
                <td>Analíticas</td>
                <td>Recogen datos sobre el comportamiento de navegación para medir y analizar el uso del sitio.</td>
                <td>1 día – 2 años</td>
                <td>Google Analytics</td>
            </tr>
            <tr>
                <td>Preferencias</td>
                <td>Almacenan información sobre tus preferencias como idioma o región.</td>
                <td>Persistente</td>
                <td>Propias</td>
            </tr>
            </tbody>
        </table>

        <h2>Cookies de terceros</h2>
        <p>Utilizamos servicios externos que pueden instalar cookies en tu dispositivo:</p>
        <ul>
            <li><strong>Google Analytics (Google LLC)</strong></li>
            <ul>
                <li>_ga: Distingue a los usuarios (2 años)</li>
                <li>_gid: Distingue a los usuarios (24 horas)</li>
                <li>_gat: Limita las solicitudes (1 minuto)</li>
            </ul>
        </ul>
        <p>Para más información: <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">Política de cookies de Google</a></p>

        <h2>3. ¿Cómo se obtiene el consentimiento?</h2>
        <p>Al acceder por primera vez, aparece un banner con las opciones:</p>
        <ul>
            <li>Aceptar todas las cookies</li>
            <li>Rechazar todas las cookies no necesarias</li>
            <li>Configurar preferencias de forma granular</li>
        </ul>
        <p>Importante: no se instalan cookies no necesarias hasta que el usuario dé su consentimiento. Puedes configurar o retirar tu consentimiento en cualquier momento desde el pie de página.</p>

        <h2>4. ¿Cómo desactivar cookies desde el navegador?</h2>
        <p>Puedes permitir, bloquear o eliminar cookies desde las opciones de tu navegador. En Chrome, Firefox, Safari, Edge encontrarás guías en sus páginas de ayuda.</p>

        <h2>5. Revisión de la política de cookies</h2>
        <p>Esta política será revisada de forma periódica y podrá modificarse para adaptarse a cambios legales o técnicos. Se recomienda revisarla con frecuencia.</p>
    </div>
);

export default Cookies;
